import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BookOpenIcon } from 'lucide-react';
const items = [{
  title: 'Guía Principal: Método Noche en Paz',
  description: 'Ebook PDF'
}, {
  title: 'El Protocolo de 7 Minutos',
  description: 'Paso a paso exacto para la hora de dormir'
}, {
  title: 'Matriz de Ventanas de Sueño',
  description: 'El horario exacto según la edad de tu bebé'
}, {
  title: 'Checklist del "Nido Perfecto"',
  description: 'Cómo configurar la habitación para un sueño ininterrumpido'
}, {
  title: 'Plan de Rescate',
  description: 'Qué hacer cuando salen los dientes o hay crisis de crecimiento'
}, {
  title: 'Diario de Progreso',
  description: 'Para ver resultados reales en menos de una semana'
}];
export function WhatYouGetSection() {
  return <section className="w-full bg-[#faf7f2] py-16 md:py-24" data-id="element-190">
      <div className="max-w-4xl mx-auto px-4" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-192">
          <div className="flex items-center justify-center gap-3 mb-12" data-id="element-193">
            <BookOpenIcon className="w-8 h-8 text-[#d4a853]" data-id="element-194" />
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] text-center" data-id="element-195">
              Todo Lo Que <span className="text-[#d4a853]" data-id="element-196">Recibes</span>
            </h2>
          </div>

          <ul className="space-y-4" data-id="element-197">
            {items.map((item, index) => <motion.li key={index} className="flex items-start gap-4 bg-white p-5 md:p-6 rounded-xl shadow-sm border border-[#ede5d8]" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} data-id="element-198">
                <CheckCircleIcon className="w-7 h-7 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-199" />
                <div data-id="element-200">
                  <p className="font-['DM_Sans'] font-semibold text-[#0f172a] text-lg" data-id="element-201">
                    {item.title}
                  </p>
                  <p className="font-['DM_Sans'] text-[#64748b] text-base" data-id="element-202">
                    {item.description}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}